// Session details data - separated to avoid babel plugin issues
export const sessionDetails = {
  1: {
    summary: 'In 2020, Tamaghna Basu demonstrated at Black Hat USA how to create an AI clone — a digital doppelganger that could chat, speak, and appear on video. Back then it required 500 voice samples, weeks of training, and custom ML pipelines. Five years later, the same clone can be created in 60 seconds using consumer tools like ElevenLabs and HeyGen. In this updated session, Tamaghna will demonstrate the terrifying evolution of AI cloning, analyze real-world attacks (including the $25M Arup heist), show how KYC and liveness detection are being bypassed, and provide practical defenses for the deepfake era.',
    topics: [
      'Evolution of AI cloning: 2020 vs 2025',
      'Live demo: creating a deepfake with consumer tools',
      'Anatomy of the $25M Arup deepfake attack',
      'How KYC and liveness detection are being bypassed',
      'Practical defenses for individuals and organizations',
    ],
    suitableFor: [
      'AI Security enthusiasts',
      'Security professionals and practitioners',
      'Risk and compliance teams',
      'Anyone curious about AI-powered social engineering',
    ],
    benefits: [
      'Live Q&A with speaker',
      'Community discussion',
    ],
  },
};
